<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_4_' + this.id]">
    <div class="background">
      <div class="daria-et-erwin">
        <div class="daria">
          <img src="https://cdn.exploreve.fr/content/personnages/daria.svg" alt="Daria" />
        </div>
        <div class="erwin">
          <img src="https://cdn.exploreve.fr/content/personnages/erwin.svg" alt="Erwin" />
        </div>
      </div>
      <div class="texts">
        <div class="bulle bulle1">
          <div class="cadre">
            <p>
              Eh bonjour ! <br />
              Ça fait longtemps que je ne vous avais pas croisé dans la Troposphère vous deux, ça fait plaisir de vous
              retrouver.
            </p>
          </div>
        </div>
        <div class="bulle bulle2">
          <div class="cadre">
            <p>
              Salut Léon ! <br />
              Désolée c’était mouvementé dans le monde réel…
            </p>
          </div>
        </div>
        <div class="bulle bulle3">
          <div class="cadre">
            <p>
              Tout ce voyage pour revenir dans la Troposphère nous a bien fatigué en revanche… Ça ne te dérange pas
              qu’on fasse une petite sieste avant de repartir à l’aventure ?
            </p>
          </div>
        </div>
        <div class="bouton">
          <NextButton class="button" url="/immersion04/2" text="Se Reposer" />
        </div>
      </div>
      <div class="leon">
        <img src="https://cdn.exploreve.fr/content/personnages/leon.svg" alt="Leon" />
      </div>
    </div>
  </div>
</template>
<script>
import NextButton from "@/components/NextButton.vue";

export default {
  name: "IM_4_1",
  components: {
    NextButton
  },
  data: function () {
    return {
      id: 1
    };
  }
};
</script>

<style scoped lang="scss">
.background {
  width: 100vw;
  height: calc(100vh - 60px);
  position: relative;
  top: 0;
  right: 0;
  background-image: url(https://cdn.exploreve.fr/content/IM3/images/jeu_ballon/interfaces/fond_conclusion_v1.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.daria-et-erwin {
  position: absolute;
  top: 12vh;
  left: 5vw;
}

.daria {
  position: absolute;
  top: 25vh;
  left: 35%;
  img {
    height: 40vh;
  }
}
.erwin {
  position: absolute;
  top: 25vh;
  left: 25%;
  img {
    height: 50vh;
  }
}
.leon {
  position: absolute;
  top: 15vh;
  right: 10vw;
  img {
    height: 60vh;
  }
  z-index: 5;
}
.texts {
  position: relative;
  width: 30vw;
  display: flex;
  flex-direction: column;
  align-items: center;

  left: calc(50vw - 250px);
  top: 5%;
  height: 90%;
}
.cadre {
  position: absolute;
  background-color: white;
  width: 30vw;
  border-radius: 15px;
  text-align: left;
  padding: 10px;
  z-index: 10;
  p {
    margin-bottom: 0 !important;
    font-family: Faune;
    font-style: normal;
    font-weight: normal;
    font-size: 3vh;
    line-height: 4vh;
  }
}
.bulle1 {
  position: absolute;
  top: 5vh;
  right: 20vw;
  & .cadre::after {
    content: "";
    position: absolute;
    left: 100%;
    bottom: 15%;
    width: 0;
    height: 0;
    transform: rotate(-90deg);
    border-left: 2.5vh solid transparent;
    border-right: 2.5vh solid transparent;
    border-top: 7vh solid white;
  }
}
.bulle2 {
  position: absolute;
  bottom: 55vh;
  left: 0;
  & .cadre::after {
    content: "";
    position: absolute;
    right: 100%;
    bottom: 15%;
    width: 0;
    height: 0;
    transform: rotate(75deg);
    border-left: 2.5vh solid transparent;
    border-right: 2.5vh solid transparent;
    border-top: 7vh solid white;
  }
}
.bulle3 {
  position: absolute;
  bottom: 37vh;
  left: 0;
  & .cadre::after {
    content: "";
    position: absolute;
    right: 100%;
    bottom: 60%;
    width: 0;
    height: 0;
    transform: rotate(105deg);
    border-left: 2.5vh solid transparent;
    border-right: 2.5vh solid transparent;
    border-top: 7vh solid white;
  }
}

.bouton {
  width: 340px;
  position: absolute;
  bottom: 0;
  left: 2vw;
  z-index: 9999;
}
</style>
